import { type SelectDashboardScene } from './SelectContent/SelectDashboardScene';

export interface SectionProps {
  dashboards?: SelectDashboardScene[];
  onAddDashboard?: () => void;
  open: boolean;
  onToggle: () => void;
  /** Whether the report's dashboards are still being loaded in (see useSelectDashboards). */
  isLoadingDashboards?: boolean;
  /**
   * Bumped by ReportForm when the last dashboard row is removed, telling SelectContent to
   * focus its own "Add dashboard" button (WCAG 2.4.3 Focus Order). A signal rather than a ref
   * passed down: the button and its ref both live in SelectContent, so SelectContent can use
   * the same plain useRef(null) idiom its own "Add page" button already uses, instead of
   * ReportForm owning a ref it writes into via a callback from across the component boundary.
   */
  addDashboardFocusSignal?: number;
}

export enum SectionId {
  SelectContent = 'select-content',
  Schedule = 'schedule',
  EmailConfiguration = 'email-configuration',
  Recipients = 'recipients',
  Attachments = 'attachments',
}
